export default "__VITE_ASSET__DKk4Ujhk__"